<form [formGroup]="form" (ngSubmit)="onFormSubmit()">
  <!-- first select a product -->
  <div class="mb-4">
    <label class="form-label">
      {{ 'productModule.product' | translate }}
    </label>
    <product-select-input
      (search)="onSearchProducts($event)"
      [products]="products$ | async"
      formControlName="productId"
      (productSelected)="productSelected($event)"
      [allowClearing]="false"
      [isDisabled]="selectedBookableSlot"
      [isFromBookingSaleCreation]="true"
    ></product-select-input>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="form.controls.productId.dirty && form.controls.productId.invalid"
    >
      {{ 'productModule.product' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>
  <div
    class="mb-4"
    [hidden]="
      !(
        (isProductBookableOrActivity$ | async) &&
        form.controls['bookingOption'].value === 'createBooking'
      )
    "
  >
    <label class="form-label" *ngIf="!this.isResource">
      {{ 'productModule.optionalLinkedToResourceText' | translate }}
    </label>
    <label class="form-label" *ngIf="this.isResource">
      {{ 'productModule.optionalLinkedToActivityText' | translate }}
    </label>
    <ng-select
      [items]="parentBookableProducts$ | async"
      [multiple]="this.isResource ? false : true"
      [searchable]="true"
      bindLabel="description"
      bindValue="id"
      formControlName="parentBookableProductsIds"
      [closeOnSelect]="true"
    >
      >
    </ng-select>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="
        form.controls.parentBookableProductsIds?.dirty &&
        form.controls.parentBookableProductsIds?.invalid
      "
    >
      <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
      {{ 'general.isRequired' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>

  <!-- customer category form control    -->
  <div
    class="mb-4"
    *ngIf="
      (!customerCategoryId || customerCategoryId == 0) && chooseCategoryAllowed$
        | async
    "
  >
    <label class="form-label">
      {{ 'saleModule.customerCategory' | translate }}
    </label>
    <select formControlName="customerCategory" class="form-select">
      <option
        *ngFor="let cat of this.categories$ | async"
        value="{{ getCategoryValue(cat) }}"
      >
        {{ cat | getCategoryDescription | async }}
      </option>
    </select>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="
        form.controls.customerCategory.dirty &&
        form.controls.customerCategory.invalid
      "
    >
      <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
      {{ 'saleModule.customerCategory' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>
  <!--  bookable items -->
  <div [hidden]="!(isProductBookableOrActivity$ | async)">
    <div class="mb-4">
      <label class="me-3">
        {{ 'bookingModule.booking' | translate }}
      </label>

      <div class="btn-group">
        <button
          (click)="setBookingOption('showCalendar')"
          [ngClass]="{
            active:
              form.controls['bookingOption'].value === 'showCalendar' &&
              !selectedBookableSlot,
            'btn-outline': form.get('bookingOption').value === 'showCalendar'
          }"
          class="btn-soft-primary btn flex-1"
          type="button"
          [disabled]="selectedBookableSlot"
        >
          <i role="img" class="fa fa-fw fa-calendar-alt" aria-hidden="true"></i>
          {{ 'bookingModule.showCalendar' | translate }}
        </button>
        <button
          (click)="setBookingOption('createBooking')"
          [ngClass]="{
            active:
              form.controls['bookingOption'].value === 'createBooking' &&
              !selectedBookableSlot,
            'btn-outline': form.get('bookingOption').value === 'createBooking'
          }"
          class="btn-soft-primary btn flex-1"
          type="button"
          [disabled]="selectedBookableSlot"
        >
          <i role="img" class="fa fa-fw fa-plus" aria-hidden="true"></i>
          {{ 'bookingModule.createBooking' | translate }}
        </button>
      </div>
    </div>
    <div class="row">
      <!-- calendar -->
      <div class="col-lg">
        <calendar
          [events]="calendarEvents$ | async"
          (onChangeDates)="onChangeDates($event)"
          (onClickDate)="onClickDates($event)"
          (onClickEvent)="onClickEvent($event)"
        ></calendar>
      </div>
      <div class="col-lg-4">
        <!--    selected bookable slot -->
        <div [hidden]="!selectedBookableSlot">
          <button
            type="button"
            class="btn btn-soft-danger btn-sm mb-3"
            attr.aria-label="{{ 'general.close' | translate }}"
            (click)="clearSelectedBookableSlot()"
          >
            <i role="img" class="fa fa-times me-1" aria-hidden="true"></i>
            {{ 'general.cancel' | translate }}
            {{ 'bookingModule.booking' | translate }}
          </button>

          <h4>{{ 'bookingModule.booking' | translate }}:</h4>

          <p *ngIf="selectedBookableSlot">
            {{ 'general.startDate' | translate }}:
            {{ form.get('startDate')?.value | date : 'HH:mm' }} -
            {{
              form.get('startDate')?.value
                | date
                  : 'EEEE d MMMM yyyy'
                  : null
                  : (config.selectedLang$ | async)
            }}
          </p>
          <p>
            {{ 'general.endDate' | translate }}:
            {{ form.get('endDate')?.value | date : 'HH:mm' | roundMinutes }} -
            {{
              form.get('endDate')?.value
                | date
                  : 'EEEE d MMMM yyyy'
                  : null
                  : (config.selectedLang$ | async)
            }}
          </p>

          <sale-item-purchase-params-form
            #salesItemsPurchase
            *ngIf="selectedProduct$ | async"
            [params]="bookableSlotParams$ | async"
            [selectedProduct]="selectedProduct$ | async"
            [resetForm$]="resetForm$"
          ></sale-item-purchase-params-form>

          <sale-item-create-survey
            *ngIf="(selectedProduct$ | async) && (selectedBookableSlot$ | async)"
            [selectedProduct]="selectedProduct$ | async"
            [selectedBookableSlot]="selectedBookableSlot$ | async"
            [submitAttempted]="surveySubmitAttempted"
            (surveyDraftChange)="onSurveyDraftChange($event)"
            (surveyLoadingChange)="onSurveyLoadingChange($event)"
          ></sale-item-create-survey>
        </div>
        <!--  start date and time for non bookable or creating booking-->
        <div
          [hidden]="
            form.get('bookingOption').value != 'createBooking' ||
            ((isProductBookableOrActivity$ | async) && selectedBookableSlot)
          "
        >
          <ng-template
            [ngTemplateOutlet]="startAndEndDateFormControls"
          ></ng-template>
        </div>
        <!--    show create booking form -->
        <div [hidden]="!(showCreateBooking$ | async) || selectedBookableSlot">
          <form [formGroup]="bookingForm"></form>
        </div>
      </div>
    </div>
  </div>

  <!--  non bookable items -->
  <div *ngIf="!(isProductBookableOrActivity$ | async)">
    <!-- quantity form control    -->
    <div class="mb-4">
      <label class="form-label">
        {{ 'general.quantity' | translate }}
      </label>

      <input
        type="number"
        class="form-control"
        placeholder="1"
        formControlName="quantity"
      />
      <p
        class="invalid"
        *ngIf="form.controls.quantity.dirty && form.controls.quantity.invalid"
      >
        <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
        {{ 'general.quantity' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <ng-template [ngTemplateOutlet]="startAndEndDateFormControls"></ng-template>

    <div
      class="mb-4"
      [hidden]="
        !(parentBookableProducts$ | async)?.length ||
        (isProductBookableOrActivity$ | async)
      "
    >
      <label class="form-label">
        {{ 'productModule.optionalLinkedToResourceText' | translate }}
      </label>
      <product-select-input
        [products]="parentBookableProducts$ | async"
        [dropdownPosition]="'top'"
        formControlName="bookableProductId"
        [allowClearing]="false"
        [isFromBookingSaleCreation]="true"
      ></product-select-input>
      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="
          bookingForm.controls.bookableProductId.dirty &&
          bookingForm.controls.bookableProductId.invalid
        "
      >
        <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
        {{ 'productModule.resource' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>
  </div>
  <ng-template #startAndEndDateFormControls>
    <div class="row mt-3">
      <fieldset class="mb-4 col-md-auto">
        <legend class="form-label">
          {{ 'general.startDateEndTime' | translate }}
        </legend>
        <div class="d-flex">
          <datetime-input
            [hideTime]="true"
            formControlName="startDate"
          ></datetime-input>
          <nz-time-picker
            formControlName="startTime"
            nzFormat="HH:mm"
            nzMinuteStep="15"
          ></nz-time-picker>
        </div>
        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="
            (form.controls.startDate.dirty &&
              form.controls.startDate.invalid) ||
            (form.controls.startTime.dirty && form.controls.startTime.invalid)
          "
        >
          <i
            role="img"
            class="fas fa-exclamation-circle"
            aria-hidden="true"
          ></i>
          {{ 'general.startDateEndTime' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </fieldset>
      <fieldset class="mb-4 col-md-auto">
        <legend class="form-label">
          {{ 'bookingModule.setEndTime' | translate }}
        </legend>
        <div>
          <nz-time-picker
            [nzDisabledHours]="disabledHours(form.get('startTime').value)"
            formControlName="endTime"
            nzFormat="HH:mm"
            nzMinuteStep="15"
          ></nz-time-picker>
        </div>
        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="
            form.controls.startTime.dirty && form.controls.startTime.invalid
          "
        >
          <i
            role="img"
            class="fas fa-exclamation-circle"
            aria-hidden="true"
          ></i>
          {{ 'general.startDateEndTime' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </fieldset>
    </div>
  </ng-template>
</form>
